import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M51.7991 12.2009C46.5105 6.91244 39.4792 4 32 4C24.5209 4 17.4895 6.91244 12.2009 12.2009C6.91244 17.4895 4 24.5209 4 32C4 39.4791 6.91244 46.5105 12.2009 51.7991C17.4895 57.0876 24.5209 60 32 60C39.4792 60 46.5105 57.0876 51.7991 51.7991C57.0876 46.5105 60 39.4791 60 32C60 24.5209 57.0876 17.4895 51.7991 12.2009ZM32 56.3479C18.5747 56.3479 7.65214 45.4255 7.65214 32C7.65214 18.5745 18.5747 7.65214 32 7.65214C45.4253 7.65214 56.3479 18.5747 56.3479 32C56.3479 45.4253 45.4253 56.3479 32 56.3479Z",
      fill: "#002565"
    }, null, -1),
    _createElementVNode("path", {
      d: "M33.8261 15.3002H30.1738V32.6884L40.3674 44.2871L43.1108 41.8761L33.8261 31.3116V15.3002Z",
      fill: "#002565"
    }, null, -1)
  ])))
}
export default { render: render }